<div class="ya-input-container">
  <div class="ya-input-wrapper">
    <div #CustomCalendarInput id="YACalendar" class="ya-calendar-wrapper" [class.has-value]="hasValue">
      <input a11y_Input numericDateInput type="tel" class="ya-input-text" id="birthdateDD" name="birthdateDD"
        [(ngModel)]="birthDateDD" maxlength="2" onselectstart="return false;" onmousedown="return false;"
        [required]="false" #birthDayInputDD="ngModel" placeholder="DD" (custom-date-keyup)="onKeyUpDateInput($event)"
        onClick="this.select();">.
      <input a11y_Input numericDateInput type="tel" class="ya-input-text" id="birthdateMM" name="birthdateMM"
        [(ngModel)]="birthDateMM" maxlength="2" [required]="false" #birthDayInputMM="ngModel" placeholder="MM"
        (custom-date-keyup)="onKeyUpDateInput($event)" onClick="this.select();">.
      <input a11y_Input numericDateInput isYear="true" type="tel" class="ya-input-text" id="birthdateYYYY"
        name="birthdateYYYY" [(ngModel)]="birthDateYYYY" maxlength="4" minlength="4" onClick="this.select();"
        [required]="false" #birthDayInputYYYY="ngModel" (custom-date-keyup)="onKeyUpDateInput($event)"
        [placeholder]="calenderIsRequired ? 'YYYY *' : 'YYYY'">
    </div>
    <div class="field_label" *ngIf="label">
      <span>{{label}}{{calenderIsRequired ? ' *' : ''}}</span>
    </div>
    <ng-content></ng-content>
  </div>
</div>